import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { User } from '../../../_shared/models/user.model';

@Component({
  selector: 'app-player-cell',
  templateUrl: './player-cell.component.html',
  styleUrls: ['./player-cell.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass]
})
export class PlayerCellComponent {
  @Input() player!: { person: User; showServerNumber: boolean };
  @Input() returningSide!: string;
  @Input() returningSideType!: string;
  @Input() serverNumber!: number;
  @Input() type!: 'score-list' | 'official-view';

  getPlayerName() {
    if (this.player?.person) {
      let playerName = `${this.player.person?.last_name}, ${this.player.person?.first_name}`;
      return playerName
    } else {
      return null;
    }
  }
}
